import ApiRoutes from './ApiRoutes'
import HTTP from './HTTPService'

export default {
  getHubs() {
    return HTTP.get(ApiRoutes.hubsURL())
  }
}
